module.exports = __webpack_public_path__ + "ground-up-cover.823657c.png";